var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavMenu'),(!(_vm.$route.meta.showNavMenu || _vm.$route.meta.showBread))?_c('Breadcrumb',{style:({ marginTop: _vm.topnavHeight + 'px' })}):_vm._e(),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }